import React from 'react';
import { injectIntl } from 'react-intl';

import messages from './classesStudentsMessages';

import './ClassesStudentsCard.scss';

function ClassesStudentsCard({
  intl,
  idCourse,
  courseName,
  levelName,
  segmentStage,
  segmentName,
  schoolName,
  studentsCount,
  period,
  idCSchool,
  canEdit,
  hasAccessToDemoSchool,
  ...props
}) {
  const canManageClass = canEdit || (hasAccessToDemoSchool && idCSchool == 406);

  return (
    <div className="card card-school classes-students-card" onClick={props.onClick}>
      <div className="card-body">
        <div
          className="class-prefix classes-students-card--prefix"
          style={{ color: '#FFFFFF', backgroundColor: '#D4A1DD', flexDirection: 'column' }}
        >
          {levelName}
          {segmentStage && (
            <div style={{ fontSize: '0.75em', opacity: 0.9, lineHeight: 1.2 }}>{segmentStage}</div>
          )}
        </div>
        <h5
          className="card-title subtitle-bigger my-0 mb-1"
          style={{ color: '#D4A1DD !important' }}
        >
          {courseName}
        </h5>
        {segmentName && (
          <p className="mb-1" style={{ fontSize: '0.85em', color: '#888' }}>{segmentName}</p>
        )}
        <p className="mb-5">{intl.formatMessage(messages.schoolName, { schoolName })}</p>
        <p className="mb-0">{intl.formatMessage(messages.studentsCount, { studentsCount })}</p>
        <p>{intl.formatMessage(messages.period, { period })}</p>

        {props.coordinator && props.isCurrentYear && (
          <div
            className="fixed-actions"
            style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}
          >
            <button
              className="edit-card"
              onClick={props.onNotify}
              style={{ position: 'relative', marginTop: -40 }}
            >
              <i className="ti-email" />
              {intl.formatMessage(messages.notify)}
            </button>
            {canManageClass && (
              <React.Fragment>
                <button
                  className="edit-card"
                  onClick={props.onEdit}
                  style={{ position: 'relative', marginTop: -40 }}
                >
                  <i className="ti-pencil-alt" />
                  {intl.formatMessage(messages.edit)}
                </button>
                <button
                  className="edit-card"
                  onClick={props.onDelete}
                  style={{ position: 'relative' }}
                >
                  <i className="ti-trash" />
                  {intl.formatMessage(messages.delete)}
                </button>
              </React.Fragment>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default injectIntl(ClassesStudentsCard);
